import { TextureLoader, CubeTextureLoader } from 'three';
import fixCornerWardrobeDepth from 'helpers/fixCornerWardrobeDepth';

export const measurements = wardrobesConfigs => {
  let isCorner = false;
  let overallWidth = 0;
  let overallHeight = 240;
  let depth = 66;
  let depth1 = 0;
  let angleWidth = 0;
  let cornerIndex = null;
  let cornerWidth = 0;
  let cornerDepth = 0;

  wardrobesConfigs.forEach((config, index) => {
    if (config.hasOwnProperty('dimensions')) {
      overallWidth += fixCornerWardrobeDepth(config, 'Narożnik 66x45', config.dimensions.x, 70);
      if (isCorner === true) {
        angleWidth += config.dimensions.x;
      }

      if (config.is_corner === true) {
        isCorner = true;
        cornerIndex = index;
        cornerWidth = config.dimensions.x;
        cornerDepth = fixCornerWardrobeDepth(config, 'Narożnik 45x66', config.dimensions.z, 70);
      }
    }
  });

  overallHeight = wardrobesConfigs[0].dimensions.y;
  depth = fixCornerWardrobeDepth(
    wardrobesConfigs[0],
    'Narożnik 45x66',
    wardrobesConfigs[0].dimensions.z,
    70,
  );

  if (isCorner === true) {
    depth1 = wardrobesConfigs[wardrobesConfigs.length - 1].dimensions.z;
  }

  return {
    overallWidth: overallWidth,
    angleWidth: angleWidth,
    cornerIndex: cornerIndex,
    cornerWidth: cornerWidth,
    cornerDepth: cornerDepth,
    overallHeight: overallHeight,
    depth: depth,
    depth1: depth1,
    isCorner: isCorner,
  };
};

export const getMatFromConfig = config => {
  const aSafo = config.safo.split('/');
  const aMmat = aSafo[aSafo.length - 1].split('-');
  const mat = aMmat[1];
  return mat;
};

export const getMatFromSafo = safo => {
  const aSafo = safo.split('/');
  const aMmat = aSafo[aSafo.length - 1].split('-');
  const mat = aMmat[1];
  return mat;
};

export const sceneTraverse = (obj, fn) => {
  if (!obj) return;

  fn(obj);

  if (obj.children && obj.children.length > 0) {
    obj.children.forEach(o => {
      sceneTraverse(o, fn);
    });
  }
};

export const loadTexture = url => {
  return new Promise(resolve => {
    new TextureLoader().load(url, resolve);
  });
};

export const loadSkyBox = urls => {
  return new Promise(resolve => {
    new CubeTextureLoader().load(urls, resolve);
  });
};
